export const columnsToExport = [
  'armador',
  'tipo',
  'tamano',
  'contenedor',
  'booking',
  'playa',
  'estado',
  'tara',
  'mgw',
  'payLoad',
  'viajeImport',
  'llegadaImport',
  'viajeExport',
  'llegadaExport',
  'estadia',
  'statusExport',
  'bloqueos',
];
